import { useMemo } from 'react'

export interface DotSegment {
  key: string
  label: string
  /** Integer dot count (callers should allocate so segments sum to 100) */
  percentage: number
  /** Display text for the tooltip; defaults to `${percentage}%` */
  percentageLabel?: string
  color: string
}

interface DotGridChartProps {
  segments: DotSegment[]
  size?: number
  gap?: number
}

export function DotGridChart({ segments, size = 28, gap = 4 }: DotGridChartProps) {
  const dots = useMemo(() => {
    const result: { color: string; label: string; pctText: string }[] = []

    for (const segment of segments) {
      const pctText = segment.percentageLabel ?? `${segment.percentage}%`
      for (let i = 0; i < segment.percentage; i++) {
        result.push({ color: segment.color, label: segment.label, pctText })
      }
    }

    return result.slice(0, 100)
  }, [segments])

  return (
    <div
      className="grid grid-cols-10 mx-auto"
      style={{ gap: `${gap}px`, width: `${10 * size + 9 * gap}px` }}
    >
      {dots.map((dot, i) => (
        <div
          key={i}
          title={`${dot.label} (${dot.pctText})`}
          className="rounded-full transition-transform hover:scale-125 cursor-default"
          style={{
            width: `${size}px`,
            height: `${size}px`,
            backgroundColor: dot.color,
          }}
        />
      ))}
    </div>
  )
}
